<template>
  <el-dialog
    :visible.sync="visible"
    width="560px"
    :title="title">
    <div v-loading="base_Top_1_loading" class="main-wrap">
      <div v-if="base_Top_1" class="left-block">
        <div
          v-for="(item) in base_Top_1"
          :key="item.cid"
          @click="topClick(item)"
          class="item">
          <el-checkbox
            :indeterminate="isIndeterminateMap[item.cid]"
            v-model="checkAllMap[item.cid]"
            @change="(val) => handleCheckAllChange(item, val)">
          </el-checkbox>
          <span style="margin-left: 8px" :class="[currentTop && currentTop.cid === item.cid ? 'hightline' : '']">
            {{item.name}}
            <span
              style="color:#c1c1c1"
              v-show="level1SelectedMap[item.cid] && level1SelectedMap[item.cid].length">
              （{{level1SelectedMap[item.cid] ? level1SelectedMap[item.cid].length : ''}}）
            </span>
          </span>
        </div>
      </div>
      <div v-if="currentTop" class="right-block">
        <el-checkbox-group
          v-model="level1SelectedMap[currentTop.cid]"
          @change="handleCheckedLevel1Change">
          <div
            class="item"
            v-for="level1 in currentTop.children"
            :key="level1.cid">
            <el-checkbox
              :label="level1.cid">
              {{level1.name}}
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleOK">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {setMainCategoryList} from '@/servers/prod/center'
import { get, find } from 'lodash'
export default {
  props: {
    title: {
      type: String,
      default: '设置主营类目'
    },
    identity: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      cb: null,
      isIndeterminateMap: {},
      checkAllMap: {},
      currentTop: null,
      level1SelectedMap: {},
    }
  },
  computed: {
    base_Top_1() {
      return this.$store.getters.base_Top_1
    },
    base_Top_1_loading() {
      return this.$store.getters.base_Top_1_loading
    },
    level1List() {
      return this.currentTop.children
    }
  },
  watch: {
    base_Top_1(v) {
      let isIndeterminateMap = {}
      let checkAllMap = {}
      let level1SelectedMap = {}
      v.forEach(item => {
        isIndeterminateMap[item.cid] = false
        checkAllMap[item.cid] = false
        level1SelectedMap[item.cid] = []
      })
      this.isIndeterminateMap = isIndeterminateMap
      this.checkAllMap = checkAllMap
      this.level1SelectedMap = level1SelectedMap
    }
  },
  methods: {
    handleCheckAllChange(item, val) {
      this.level1SelectedMap[item.cid] = val ? item.children.map(c => c.cid) : []
      this.isIndeterminateMap[item.cid] = false
    },
    handleCheckedLevel1Change(value) {
      let checkedCount = value.length;
      const {cid, children} = this.currentTop
      this.checkAllMap[cid] = checkedCount === children.length
      this.isIndeterminateMap[cid] = checkedCount > 0 && checkedCount < children.length
    },
    topClick(item) {
      this.currentTop = item
    },
    method_open(mainList, cb) {
      this.cb = cb
      this.visible = true
      let map = {}
      // 初始化leve1所选数据
      mainList.forEach(item => {
        if (map[item.parentCid]) {
          map[item.parentCid].push(item.cid)
        } else {
          map[item.parentCid] = [item.cid]
        }
      })
      // 初始化top状态
      const pcids = Object.keys(map).forEach(parentCid => {
        const baseTop = this.base_Top_1.find(b => b.cid === Number(parentCid))
        if (!baseTop) return ;
        this.level1SelectedMap[parentCid] = map[parentCid]
        this.isIndeterminateMap[parentCid] = true
        if (map[parentCid].length === baseTop.children.length) {
          this.checkAllMap[parentCid] = true
          this.isIndeterminateMap[parentCid] = false
        }
      })
    },
    close() {
      this.visible = false
    },
    getFullData() {
      let data = []
      let keys = Object.keys(this.level1SelectedMap);
      keys.forEach(elem => {
        let parents = this.level1SelectedMap[elem]
        if (parents.length > 0) {
          let obj = find(this.base_Top_1, {
            cid: +elem
          });
          let children = get(obj, 'children', []);
          let arr = children.filter(item => parents.includes(item.cid));
          data = [
              ...data,
              ...arr
          ]
        }
      })
      return data;
    },
    getData() {
      let arr = []
      for (const parentCid in this.level1SelectedMap) {
        if (this.level1SelectedMap[parentCid].length) {
          arr = arr.concat([...this.level1SelectedMap[parentCid].map(item => ({parentCid, cid: item}))])
        }
      }
      return arr
    },
    async handleOK() {
      // 分销商名片-找货需求
      if (this.identity === 'myDistributorCard') {
        this.cb && this.cb({
          data: this.getData(),
          showData: this.getFullData()
        })
        this.close()
        return;
      }
      try {
        const categoryOptions = await setMainCategoryList(this.getData())
        this.$message.success('设置成功')
        this.cb && this.cb(categoryOptions)
        this.close()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-wrap {
  height: calc(100vh - 400px);
  display: flex;
  position: relative;
  .left-block, .right-block {
    width: 260px;
    height: 100%;
    overflow-y: auto;
    border: 1px solid #e4e7ed;
  }
  .right-block {
    border-left: none;
    .item {
      padding: 0;
      label {
        padding: 0 30px 0 20px;
      }
    }
  }

  .item {
    cursor: pointer;
    height: 34px;
    line-height: 34px;
    padding: 0 30px 0 20px;
    width: 100%;
    display: flex;
    user-select: none;
    font-size: 12px;
    &:hover {
      background: #e4e7ed;
    }
  }
  .hightline {
    color: #396CF3;
  }
}
</style>